import NotFoundPage from './not-found.page';

export default function NotFoundContainer() {
  return (
    <NotFoundPage />
  );
}
